const fontFamily = {
  el: 'Roboto, Poppins',
  sk: 'Roboto, Poppins',
  sl: 'Roboto, Poppins',
  default: 'Poppins, Roboto',
};

export default fontFamily[process.env.GATSBY_BUILD_LANGUAGE || 'uk'] ||
  fontFamily.default;
